<template>
	<div
		v-if="linkUrl.length && linkLabel.length"
		class="learn-more-link-container"
	>
		<a
			:href="linkUrl"
			:target="linkTarget"
			class="learn-more-link"
		>{{ linkLabel }}</a>
	</div>
</template>


<style lang="scss">
.learn-more-link-container {
	text-align: center;
	margin-top: 36px;
	margin-bottom: 36px;
}

.learn-more-link {
	font-weight: bolder;
	font-size: 18px;
}
</style>


<script setup>
import { computed } from 'vue'


const props = defineProps({
	link: {
		type: Object,
		default: ( () => {}),
	},
})


const linkUrl = computed( () => props.link?.url || '' )
const linkTarget = computed( () => props.link?.target || 'self' )
const linkLabel = computed( () => props.link?.title || '' )
</script>
